import { render, staticRenderFns } from "./UploadsProgressFooter.vue?vue&type=template&id=7b37d614&"
import script from "./UploadsProgressFooter.vue?vue&type=script&lang=js&"
export * from "./UploadsProgressFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports